export const formatDataForVariantForm = (data, productData) => {
    const options = []
    const dataOptions = [...data.options]

    data.variantResources = {}

    if (data.resources?.length > 0) {
        data.resources.forEach(resource => {
            if (data.variantResources.hasOwnProperty(resource?.productResource?.type)) {
                data.variantResources[resource.productResource.type] = [
                    ...data.variantResources[resource.productResource.type],
                    resource.productResource['@id'],
                ]
            } else {
                data.variantResources[resource.productResource.type] = [
                    resource.productResource['@id'],
                ]
            }
        })
    }

    !!productData?.options &&
        productData?.options.forEach(option => {
            const opts = dataOptions.find(val => {
                return val.productOption['@id'] === option['@id']
            })

            const optionData = {
                displayValue: opts?.displayValue || '',
                altValue: opts?.altValue || null,
                identifier: opts?.identifier || null,
                productOption: option,
            }

            if (opts?.hasOwnProperty('@id') && opts['@id']) {
                optionData['@id'] = opts['@id']
            }

            options.push(optionData)
        })

    return {
        ...data,
        options: !!options ? options : data.options,
    }
}
